export default "__VITE_ASSET__76acfaf8__"